import React from "react";

const MedicalAbstractBackground = () => {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: -1,
        backgroundColor: "#F5F8FC", // soft medical white
      }}
    />
  );
};

export default MedicalAbstractBackground;
